import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardSubtitle, Form, Container, Button, Alert, Modal, UncontrolledTooltip, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { Config, HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as be from 'helpers/backend_helper';
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import Tasks from "../Dashboard/tasks"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
import { useParams} from 'react-router-dom';
import SPMap from 'pages/WQ/Maps/SPMap';
import FMap from 'pages/WQ/Maps/FMaps';


    const WorkOrderDetails = () => {
        const {id} = useParams()
        const [workTypeOptions, setWorkTypeOptions] = useState([])
        const [facilityOptions, setFacilityOptions] = useState([])
        const [isloading, setIsloading] = useState(false);
        const [selectedWorkType, setSelectedWorkType] = useState(null)
        const [selectedWorkTypeLevel, setSelectedWorkTypeLevel] = useState('E')

        const [trade, setTrades] = useState(['Electrical','Mechanical','Civil','Automotive','Plumbing','General'])
        const [maintenanceTypes, setMaintenanceTypes] = useState(['Planned','Unplanned'])
        const [taskTypes, setTaskTypes] = useState(['Corrective','Breakdown','Service','Installation','Modification','PPM'])
        const [priority, setPriority] = useState(['High','Medium','Low'])
        const [staffRoles, setStaffRoles] = useState(['Team Leader','Electrician','Mechanic','Mate','Casual','Driver','Engineer','Plumber','Team member'])
        const [staffOptions, setStaffOptions] = useState([])

        const [facilityId, setFacilityId] = useState('')
        const [equipmentId, setEquipmentId] = useState('')
        const [equipmentName, setEquipmentName] = useState('')
        const [facilityName, setFacilityName] = useState('')
        const [selectedFacilityName, setSelectedFacilityName] = useState('')
        const [request, setRequest] = useState('')
        const [requestedByName, setRequestedByName] = useState('')
        const [dateTimeRequested, setDateTimeRequested] = useState('')
        const [requestId, setRequestId] = useState('')
        const [requestSchemeName, setRequestSchemeName] = useState('')
        const [requestAreaName, setRequestAreaName] = useState('')


        const [team, setTeam] = useState([])
        const [member, setMember] = useState(null)
        const [role, setRole] = useState('')

        const [title, setTitle] = useState('')
        const [assignedBy, setAssignedBy] = useState('')
        const [assignedById, setAssignedById] = useState('')
        const [dateTimeAssigned, setDateTimeAssigned] = useState(null)
        const [selectedPriority, setSelectedPriority] = useState('')
        const [selectedTaskType, setSelectedTaskType] = useState('')
        const [selectedMaintenanceType, setSelectedMaintenanceType] = useState('')
        const [jobNo, setJobNo] = useState('')
        const [selectedTrade, setSelectedTrade] = useState('')
        const [workStatus, setWorkStatus] = useState('')

        const [taskFacilityId, setTaskFacilityId] = useState('')
        const [taskEquipmentId, setTaskEquipmentId] = useState('')
        const [taskEquipmentName, setTaskEquipmentName] = useState('')
        const [taskFacilityName, setTaskFacilityName] = useState('')
        
        const [previousWorks, setPreviousWorks] = useState([])
        const [taskUpdates, setTaskUpdates] = useState([])
        const [spares, setSpares] = useState([])
        const [report, setReport] = useState(false)

        const [sparesOptions, setSparesOptions] = useState([])
        const [item, setItem] = useState(null)
        const [count, setCount] = useState('')
        const [countOptions, setCountOptions] = useState(['No(s)','Meters','cm','Kgs','Grammes','mg(s)','Litres','ml(s)','Boxes','Catons','Dozens','Pairs'])
        const [quantity, setQuantity] = useState(0)

        const [updateDateTime, setUpdateDateTime] = useState([new Date()])
        const [updateDetails, setUpdateDetails] = useState('')

        const [modal_line, setmodal_line] = useState(false)
        const [modal_spares, setmodal_spares] = useState(false)
        const [modal_updates, setmodal_updates] = useState(false)
        const [modal_report, setmodal_report] = useState(false)

        const [dateTimeStarted, setDateTimeStarted] = useState([new Date()])
        const [dateTimeCompleted, setDateTimeCompleted] = useState([new Date()])
        const [rootCause, setRootCause] = useState('')
        const [partsAffected, setPartsAffected] = useState('')
        const [workDone, setWorkDone] = useState('')
        const [recommendations, setRecommendations] = useState('')
        const [taskResults, setTaskResults] = useState('')
        const [params, setParams] = useState('')
        const [createdById, setCreatedById] = useState('')
        const [closedByName, setClosedByName] = useState('')
        const [userId, setUserId] = useState('')
        const [userName, setUserName] = useState('')
        const [approverId, setApproverId] = useState('')
        const [allowedToSubmit, setAllowedToSubmit] = useState(false)
        
        const [action, setAction] = useState('')
        const [comment, setComment] = useState('')
        const [approvalId, setApprovalId] = useState('')

        const [points, setPoints] = useState([])
        const [pipes, setPipes] = useState([])

        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        
        const handleTradeChange = (e) =>{
            setSelectedTrade(e.target.value)
            setIsloading(true)
            axios.get(`${url.JOBCARD}?${e.target.value}`, Config).then((r)=>{
                setJobNo(r.data.card)
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        
        const handleDeleteWO = () =>{
            const data = {
                id          : be.decryptId(id), 
                title       : title,
                assetType   : 'Equipment',
                eqId        : equipmentId,
                faId        : facilityId,
                requestId   : requestId,
                trade       : selectedTrade,
                jobNo       : jobNo,
                type        : selectedTaskType,
                maintenance : selectedMaintenanceType,
                priority    : selectedPriority,
                assignedOn  : dateTimeAssigned,
                assignedBy  : userId,
                team        : team,
                status      :'Pending',
                createdBy   : userId,
                action      : 'delete'
             }
            
             setIsloading(true)
             axios.post(url.WORDERS, JSON.stringify(data), Config).then((r)=>{
                toastr.success(r.data.message)
                if(r.data.status == 1){
                    history.push(`/Work-Order-Management`)
                }
                setIsloading(false)
             }).catch((e)=>{
                console.log(e)
                setIsloading(false)
             })
        }
        const handlePPMPDFWO = () =>{
            const data = {
                id          : be.decryptId(id), 
                title       : title,
                assetType   : 'Facility',
                faId        : facilityId,
                requestId   : requestId,
                trade       : selectedTrade,
                jobNo       : jobNo,
                type        : selectedTaskType,
                maintenance : selectedMaintenanceType,
                priority    : selectedPriority,
                assignedOn  : dateTimeAssigned,
                assignedBy  : userId,
                team        : team,
                createdBy   : userId
            }
             setIsloading(true)
             axios.post(url.PRINTPPM, JSON.stringify(data), Config).then((r)=>{
               const urlx = url.APACHE_URL + r.data.card
               axios({
                   url: urlx,
                   method: 'GET',
                   responseType: 'blob',
                 })
                 .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `PPM_Jobcard_${jobNo}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                  })
                  .catch((error) => {
                    console.error('Error downloading the file:', error);
                  });
               setIsloading(false)
             }).catch((e)=>{
               console.log(e)
               setIsloading(false)
             })
        }
        const handlePDFWO = () =>{
            const data = {
                id          : be.decryptId(id), 
                title       : title,
                assetType   : 'Equipment',
                eqId        : equipmentId,
                faId        : facilityId,
                requestId   : requestId,
                trade       : selectedTrade,
                jobNo       : jobNo,
                type        : selectedTaskType,
                maintenance : selectedMaintenanceType,
                priority    : selectedPriority,
                assignedOn  : dateTimeAssigned,
                assignedBy  : userId,
                team        : team,
                createdBy   : userId
             }

             setIsloading(true)
             axios.post(url.PRINTCORRECTIVE, JSON.stringify(data), Config).then((r)=>{
                const urlx = url.APACHE_URL + r.data.card
                axios({
                   url: urlx,
                   method: 'GET',
                   responseType: 'blob',
                 })
                 .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Jobcard_${jobNo}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                  })
                  .catch((error) => {
                    console.error('Error downloading the file:', error);
                  });
               setIsloading(false)
             }).catch((e)=>{
               console.log(e)
               setIsloading(false)
             })
        }
        const handleUpdateWO = () =>{
            if(dateTimeStarted[0] == dateTimeCompleted[0]){
                toastr.error('Start and completion dates and time cannot be the same')
            }else if(workDone.trim().length < 5){
                toastr.error('Please describe the work done')
            }else{
                const data = {
                    wId                 : be.decryptId(id),
                    dateTimeStarted     : dateTimeStarted[0].toISOString().slice(0, 19).replace('T', ' '),
                    dateTimeCompleted   : dateTimeCompleted[0].toISOString().slice(0, 19).replace('T', ' '),
                    rootCause           : rootCause,
                    partsAffected       : partsAffected,
                    workDone            : workDone,
                    recommendations     : recommendations,
                    params              : params,
                    taskResult          : taskResults,
                    createdBy           : userId,
                    action              : 'add'
                }
                setIsloading(true)
                axios.post(url.WREPORT, JSON.stringify(data), Config).then((r)=>{
                    toastr.info(r.data.message)
                    if(r.data.status == 1){
                        tog_report()
                        setReport(true)
                        fetchData()
                    }  
                    setIsloading(false)  
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }  
        }
        const handleSendForApproval = () =>{
            if(team.length < 1){
                toastr.warning("Select at least one team member")
            }else if(!report){
                toastr.warning("Generate report first before sending for approval")
            }else{
                setIsloading(true)
                const data = {
                    action  : 'request', 
                    no      : jobNo,
                    entity  : 'Work order', 
                    id      : be.decryptId(id), 
                    userId  : userId, 
                    comment : 'comment', 
                    aid     : 'aid', 
                    rid     : 'rid'
                }
                axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == 1){
                        toastr.success(r.data.message)
                        fetchData()
                    }else{
                        toastr.error(r.data.message)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            } 
        }
        const handleCancelApproval = () =>{
            setIsloading(true)
            const data = {
                action  : 'cancel', 
                entity  : 'Work order',
                no      : jobNo, 
                id      : be.decryptId(id), 
                userId  : userId, 
                comment : 'comment', 
                aid     : 'aid', 
                rid     : 'rid'
            }
            axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleApproval = () =>{
            if(action == ""){
                toastr.error('You can select Approve or Reject Work order')
            }else{
                if((action == "Reject") && (comment.trim().length < 4)){
                    toastr.error("Please state reason for rejecting")
                }else{
                    const data = {
                        action  : action, 
                        entity  : 'Work order', 
                        no      : jobNo,
                        id      : be.decryptId(id), 
                        userId  : userId, 
                        comment : comment,
                        rid     : requestId
                    }
                  
                    setIsloading(true)
                    axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                        if(r.data.status == 1){
                            toastr.success(r.data.message)
                            fetchData()
                        }else{
                            toastr.error(r.data.message)
                        }
                        setIsloading(false)
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                }
            }
        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const tog_spares = () => {
            setmodal_spares(!modal_spares);
            removeBodyCss();
        }
        const tog_updates = () => {
            setmodal_updates(!modal_updates);
            removeBodyCss();
        }
        const tog_report = () => {
            setmodal_report(!modal_report);
            removeBodyCss();
        }
        const handleAddSpare = () =>{
            const data = {
                wId     : be.decryptId(id),
                spare   : item.value,
                unit    : count,
                quantity: quantity,
                action  : 'add'
            }
            setIsloading(true)
            axios.post(url.SPARES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setIsloading(false)
                tog_spares()
                setItem(null)
                setCount('')
                setQuantity(0)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleRemoveSpare = (k) =>{
            const data = {
                id      : spares[k].id,
                wId     : 'xxxx',
                spare   : 'xxxx',
                unit    : 'xxxx',
                quantity: 'xxxx',
                action  : 'delete'
            }
            setIsloading(true)
            axios.post(url.SPARES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const addLine = () =>{
            const data = {
                wId:be.decryptId(id),
                sId:member.value,
                role: role,
                action: 'add'
            }
            setIsloading(true)
            axios.post(url.WORDERSTAFF, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setIsloading(false)
                tog_line()
                setMember(null)
                setRole('')
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const addUpdate = () =>{
            const data = {
                wId     : be.decryptId(id),
                dateTime: updateDateTime[0].toISOString().slice(0, 19).replace('T', ' '),
                details : updateDetails,
                action  : 'add'
            }

            setIsloading(true)
            axios.post(url.WUPDATE, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setIsloading(false)
                setUpdateDetails('')
                tog_updates()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleRemoveItem = (k)=>{
        
            const data = {
                wId     : be.decryptId(id),
                sId     : team[k].memberId,
                role    : team[k].role,
                action  : 'delete'
            }
            setIsloading(true)
            axios.post(url.WORDERSTAFF, JSON.stringify(data), Config).then((r)=>{
                toastr.warning(r.data.message)
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
       
    
        const fetchData = () =>{
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id)
            setUserName(obj.username)
            const data = {id : be.decryptId(id)}
            setIsloading(true)
            axios.post(`${url.WORDERSFILTER}`, JSON.stringify(data), Config).then((r)=>{
                setTitle(r.data[0].title)
                setRequestId(r.data[0].requestId)
                setTeam(r.data[0].team)
                setSpares(r.data[0].spares)
                setTaskUpdates(r.data[0].updates)
                setSelectedMaintenanceType(r.data[0].maintenance)
                setSelectedTaskType(r.data[0].type)
                setSelectedTrade(r.data[0].trade)
                setSelectedPriority(r.data[0].priority)
                setDateTimeAssigned(Date(r.data[0].assignedOn))
                setAssignedBy(r.data[0].assignedBy)
                setWorkStatus(r.data[0].workStatus)
                setJobNo(r.data[0].card)
                setTaskFacilityId(r.data[0].faId)
                setTaskFacilityName(r.data[0].facilityName)
                setTaskEquipmentId(r.data[0].eqId)
                setTaskEquipmentName(r.data[0].equipmentName)
                setAssignedBy(r.data[0].createdBy)
                setFacilityName(r.data[0].facilityName)
                setDateTimeRequested(r.data[0].dateTimeRequested)
                setRequestedByName(r.data[0].requestedByName)
                setRequest(r.data[0].requestDetails)
                setRequestSchemeName(r.data[0].schemeName)
                setRequestAreaName(r.data[0].areaName)
                setClosedByName('')
                const fdata = {"facilityId" : r.data[0].faId}
                axios.post(`${url.WORDERSFILTER}`, JSON.stringify(fdata), Config).then((rq)=>{
                    setPreviousWorks(rq.data)
                }).catch((eq)=>{ console.log(eq) })
                const mData = {filter:r.data[0].faId}
                axios.post(url.GEOCOORDINATES, JSON.stringify(mData), Config).then((rr)=>{ setPoints(rr.data); }).catch((re)=>{ console.log(re)})
                if((r.data[0].start.length > 2) && (r.data[0].finish.length > 2)){
                    setReport(true)
                    setDateTimeStarted([new Date(r.data[0].start)])
                    setDateTimeCompleted([new Date(r.data[0].finish)])
                    setRootCause(r.data[0].rootCause)
                    setPartsAffected(r.data[0].partsAffected)
                    setWorkDone(r.data[0].workDone)
                    setRecommendations(r.data[0].recommendations)
                    setParams(r.data[0].params)
                    setTaskResults(r.data[0].taskResults)
                    setClosedByName(r.data[0].createdBy)
                }else{
                    setDateTimeStarted([new Date()])
                    setDateTimeCompleted([new Date()])
                }
                setApproverId(r.data[0].approverId)
                setCreatedById(r.data[0].createdById)
                if((obj.id == r.data[0].createdById) || (r.data[0].team.some(item => item.memberId === obj.id))){
                    setAllowedToSubmit(true)
                }
                setApproverId(r.data[0].approverId)
                setApprovalId(r.data[0].approvalId)
                setIsloading(false)
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
            axios.get(`${url.WTYPES}`, Config).then((r)=>{
                let options = []
                r.data.map((d)=>{
                    options.push({label:d.type, value:d})
                })
                setWorkTypeOptions(options)
            }).catch((e)=>{
                console.log(e)
            })
            axios.get(url.FACILITIES, Config).then((r)=>{
                let options = []
                r.data.map((f)=>{
                    options.push({label:f.facility, value:f})
                })
                setFacilityOptions(options)
            }).catch((e)=>{
                console.log(e)
            })
            axios.get(`${url.STAFF}`, Config).then((r)=>{
                let options = []
                r.data.map((s)=>{
                    options.push({label:s.name, value:s.id})
                })
                setStaffOptions(options)
            }).catch((e)=>console.log(e))
            axios.get(`${url.SPARES}?GROUP`, Config).then((r)=>{
                let options = []
                r.data.map((d)=>{
                    options.push({label:d.spare, value:d.spare})
                })
                setSparesOptions(options)
            }).catch((e)=>{
                console.log(e)
            })
        }
       
        useEffect(() => {
          fetchData()
        },[])

        const handleCreateOption = (inputValue) => {
            const newOption = { value: inputValue, label: inputValue };
            setItem(newOption)
        }
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Work order details | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.COMPANY} breadcrumbItem="Work order details" />
               
                   
                        <Row>
                        <Col xl={4}>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Work request details</h5>
                            <CardBody>  



                             <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Select Team` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Name</label>
                                            <Select options={staffOptions} value={member} onChange={(data)=>setMember(data)}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Role</label>
                                            <select className="form-select" onChange={(e)=>setRole(e.target.value)} value={role}>
                                                <option value=''></option>
                                                {staffRoles.map((s,k)=>(
                                                    <option key={k} value={s}>{s}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={addLine}>Add...</button> )
                                }</div>
                                </Modal> 

                                
                             <Modal isOpen={modal_spares} toggle={() => { tog_spares(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Spares and Materials` }</h5>
                                    <button type="button"  onClick={() => { setmodal_spares(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Item</label>
                                            <CreatableSelect  options={sparesOptions} onCreateOption={handleCreateOption} value={item} onChange={(i)=>setItem(i)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Count</label>
                                            <select className='form-select' value={count} onChange={(e)=>setCount(e.target.value)}>
                                                <option value=''></option>
                                                {countOptions.map((c,k)=>(
                                                    <option key={k} value={c}>{c}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Quantity used</label>
                                            <input type='number' className='form-control' value={quantity} onChange={(e)=>setQuantity(e.target.value)}/>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleAddSpare}>Add...</button> )
                                }</div>
                                </Modal> 

                                <Modal isOpen={modal_updates} toggle={() => { tog_updates(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Task Updates` }</h5>
                                    <button type="button"  onClick={() => { setmodal_updates(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Date and time</label>
                                            <input type='text' className='form-control' value={updateDateTime} onChange={(e)=>setUpdateDateTime(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Details</label>
                                            <textarea rows={7} className='form-control' value={updateDetails} onChange={(e)=>setUpdateDetails(e.target.value)}/>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={addUpdate}>Save update...</button> )
                                }</div>
                                </Modal> 

                                <Modal isOpen={modal_report} toggle={() => { tog_report(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Work order report` }</h5>
                                    <button type="button"  onClick={() => { setmodal_report(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Date of start of Job</label>
                                        <Flatpickr className="form-control"
                                            value={dateTimeStarted}
                                            onChange={(d)=>{setDateTimeStarted(d)}}
                                            disabled={(workStatus == 'Closed')?true:false}
                                            options={{ altInput: true, enableTime: true, dateFormat: "Y-m-d H:i", disabled: true }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Date of Job completion</label>
                                        <Flatpickr className="form-control"
                                            value={dateTimeCompleted}
                                            onChange={(d)=>{setDateTimeCompleted(d);}}
                                            disabled={(workStatus == 'Closed')?true:false}
                                            options={{ altInput: true, enableTime: true, dateFormat: "Y-m-d H:i", disabled: true }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Root causes of failure</label>
                                        <textarea rows={4} className="form-control" value={rootCause} onChange={(e)=>setRootCause(e.target.value)} disabled={(workStatus == 'Closed')?true:false}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Parts affected and Damage Found</label>
                                        <textarea rows={4} className="form-control" value={partsAffected} onChange={(e)=>setPartsAffected(e.target.value)} disabled={(workStatus == 'Closed')?true:false}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Detailed description of work done</label>
                                        <textarea rows={5} className="form-control" value={workDone} onChange={(e)=>setWorkDone(e.target.value)} disabled={(workStatus == 'Closed')?true:false}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Recommendations/Remarks</label>
                                        <textarea rows={4} className="form-control" value={recommendations} onChange={(e)=>setRecommendations(e.target.value)} disabled={(workStatus == 'Closed')?true:false}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Final operating parameters e.g. Current, Voltage, Flow..</label>
                                        <textarea rows={4} className="form-control" value={params} onChange={(e)=>setParams(e.target.value)} disabled={(workStatus == 'Closed')?true:false}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Task results</label>
                                        <select className="form-select" value={taskResults} onChange={(e)=>setTaskResults(e.target.value)} disabled={(workStatus == 'Closed')?true:false}>
                                            <option value=''></option>
                                            <option value='Completed'>Completed</option>
                                            <option value='More work needed to be done'>More work needed to be done</option>
                                        </select>
                                        </div>
                                    </Col>
                                   
                                </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleUpdateWO}>Submit report...</button> )
                                }</div>
                                </Modal> 

                                <Row>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Area</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={requestAreaName} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Scheme</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={requestSchemeName} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Facility</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={facilityName} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Requested by</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={requestedByName} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Date and time requested</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={dateTimeRequested} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Request Details</label>
                                            <textarea rows={4}  className="form-control" disabled={true} defaultValue={request} />
                                        </div>
                                    </Col>
                                </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                                             
                                <FMap points={points} pipes={pipes}/>
                                
                            </Card>
                            
                            </Col>
                            <Col xl={8}>
                 
                 <Card>
                 <h5 className="card-header bg-transparent border-bottom text-uppercase">Work order details</h5>
                     <CardBody>
                         <Row>
                            <Col md={12}>
                                <div className="mb-3">
                                <label>Job Title</label>
                                <input type='text' className='form-control' value={title} onChange={(e)=>setTitle(e.target.value)} disabled={(workStatus == 'Open')?false:true}/>
                                </div>
                            </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Select trade</label>
                                 <select className="form-select" value={selectedTrade} onChange={(e)=>handleTradeChange(e)} disabled={(workStatus == 'Open')?false:true}>
                                     <option value=''></option>
                                     {trade.map((t,k)=>(
                                         <option key={k} value={t}>{t}</option>
                                     ))}
                                 </select>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Work order number/Job no</label>
                                 <input type='text' className="form-control" defaultValue={jobNo} disabled={true}/>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Maintenance type</label>
                                 <select className="form-select" value={selectedMaintenanceType} onChange={(e)=>setSelectedMaintenanceType(e.target.value)} disabled={(workStatus == 'Open')?false:true}>
                                 <option value=''></option>
                                     {maintenanceTypes.map((t,k)=>(
                                         <option key={k} value={t}>{t}</option>
                                     ))}
                                 </select>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Task type</label>
                                 <select className="form-select" value={selectedTaskType} onChange={(e)=>setSelectedTaskType(e.target.value)} disabled={(workStatus == 'Open')?false:true}>
                                     <option value=""></option>
                                     {taskTypes.map((t,k)=>(
                                         <option key={k} value={t}>{t}</option>
                                     ))}
                                 </select>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Priority</label>
                                 <select className="form-select" value={selectedPriority} onChange={(e)=>setSelectedPriority(e.target.value)} disabled={(workStatus == 'Open')?false:true}>
                                 <option value=''></option>
                                     {priority.map((t,k)=>(
                                         <option key={k} value={t}>{t}</option>
                                     ))}
                                 </select>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Date and time assigned</label>
                                 <Flatpickr className="form-control"
                                     value={dateTimeAssigned}
                                     onChange={(d)=>{setDateTimeAssigned(d)}}
                                     disabled={(workStatus == 'Open')?false:true}
                                     options={{ altInput: true, enableTime: true, dateFormat: "Y-m-d H:i", disabled: true }}
                                 />
                                 </div>
                             </Col>
                            
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Assigned by</label>
                                 <input type='text' className="form-control" defaultValue={assignedBy} disabled={true}/>
                                 </div>
                             </Col>
                             <Col md={6}>
                                 <div className="mb-3">
                                 <label>Status</label>
                                 <input type='text' className="form-control" defaultValue={workStatus} disabled={true}/>
                                 </div>
                             </Col>

                         </Row>
                         
                     </CardBody>
                 </Card>
                 <Card>
                    <h5 className="card-header bg-transparent border-bottom text-uppercase">Team</h5>
                                <CardBody>
                                
                                <div>
                                {(team.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Name</th>
                                                            <th>Role</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {team.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>{a.member.label}</td>
                                                                <td>{a.role}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                {(workStatus == 'Open') && allowedToSubmit && (
                                                                    <div className="d-flex gap-3">
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => handleRemoveItem(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                    </></td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No staff assigned</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                            
                     
                                        </div>
                                        {(workStatus == 'Open') && allowedToSubmit && (
                                            <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="success"
                                                        className="btn btn-rounded"
                                                        onClick={() => { tog_line(); }}
                                                        >
                                                        Add team members
                                                    </Button>
                                                </div>
                                            </Col>
                                            </Row>
                                        )}
                                    
                                     
                                            </CardBody>
                                        </Card>


                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Parts and materials used</h5>
                                <CardBody>
                           
                                
                                <div>
                                {(spares.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Item</th>
                                                            <th>Count</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Quantity</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {spares.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>{a.spare}</td>
                                                                <td>{a.unit}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.quantity}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                {(workStatus == 'Open') && allowedToSubmit && (
                                                                    <div className="d-flex gap-3">
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => handleRemoveSpare(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                    </></td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No spares and materials used</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                            
                     
                                        </div>
                                        {(workStatus == 'Open') && allowedToSubmit && (
                                        <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="success"
                                                        className="btn btn-rounded"
                                                        onClick={() => { tog_spares(); }}
                                                        >
                                                        Add spares and materials
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                        )}
                                    
                                     
                                            </CardBody>
                                        </Card>
                         
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Task Updates</h5>
                                <CardBody>
                                
                                <div>
                                {(taskUpdates.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>Date and Time</th>
                                                            <th>Details</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {taskUpdates.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.dateTime}</td>
                                                                <td>{a.details}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                {(workStatus == 'Open') && (
                                                                    <div className="d-flex gap-3">
                                                               
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => handleRemoveSpare(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                    </></td>
                                                                
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No task updates reported</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {(workStatus == 'Open') && allowedToSubmit && (
                                        <Row className="mb-2 mt-3 justify-content-center">
                                       
                                        <Col md={4} className='mb-3'>
                                            <div className="d-grid gap-2">
                                                <Button color="warning" className="btn btn-rounded" onClick={tog_updates}>
                                                    Add Task update
                                                </Button>
                                            </div>
                                        </Col>
                                       
                                        </Row>
                                        )}
                                    </CardBody>
                                </Card>

                                <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Work order report</h5>
                                <CardBody>
                                
                                
                                {(report) ? (
                                           
                                                <>
                                                    <h5 className="font-size-15 mt-0">Root cause :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{rootCause}</p>
                                                    <h5 className="font-size-15 mt-2">Parts affected :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{partsAffected}</p>
                                                    <h5 className="font-size-15 mt-2">Work done :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{workDone}</p>
                                                    <h5 className="font-size-15 mt-2">Recommendations :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{recommendations}</p>
                                                    <h5 className="font-size-15 mt-2">Final Operating Parameters :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{params}</p>
                                                    <h5 className="font-size-15 mt-2">Task Results :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{taskResults}</p>
                                                    <h5 className="font-size-15 mt-2">Closed by :</h5><p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{closedByName}</p>
                                                    <Row className="task-dates">
                                                    <Col sm="4" xs="6">
                                                        <div className="mt-2">
                                                        <h5 className="font-size-14">
                                                            <i className="bx bx-calendar me-1 text-primary" /> Start Date
                                                        </h5>
                                                        <p className="text-muted mb-0">{dateTimeStarted.toLocaleString()}</p>
                                                        </div>
                                                    </Col>
                                                    <Col sm="4" xs="6">
                                                        <div className="mt-4">
                                                        <h5 className="font-size-14">
                                                            <i className="bx bx-calendar-check me-1 text-primary" /> Completion Date
                                                        </h5>
                                                        <p className="text-muted mb-0">{dateTimeCompleted.toLocaleString()}</p>
                                                        </div>
                                                    </Col>
                                                    </Row>
                                                </>
                                                
                                            ):(
                                                <>
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No work order report submitted</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                           {(workStatus == 'Open') && allowedToSubmit && (
                                                <Row className="mb-2 mt-3 justify-content-center">
                                                    <Col md={4} className='mb-3'>
                                                        <div className="d-grid gap-2">
                                                            <Button color="warning" className="btn btn-rounded" onClick={tog_report}>
                                                                Submit task report
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}
                                        </>
                                        )}
                                    </CardBody>
                                </Card>
                             

                                {((workStatus == 'Pending Approval') && (userId == approverId)) ? '': (
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Work order Actions</h5>
                                <CardBody>
                               
                                
                                <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={5} className='mb-3'>
                                                {(selectedTaskType == 'PPM')?(
                                                <div className="d-grid gap-2">
                                                    <Button color="primary" className="btn btn-rounded" onClick={handlePPMPDFWO} >
                                                        Generate PPM Jobcard
                                                    </Button>
                                                </div>
                                                ):(
                                                <div className="d-grid gap-2">
                                                    <Button color="primary" className="btn btn-rounded" onClick={handlePDFWO} >
                                                        Generate Jobcard
                                                    </Button>
                                                </div>)} 
                                            </Col>
                                        {(workStatus == 'Open') && allowedToSubmit && (
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" className="btn btn-rounded" onClick={handleDeleteWO} >
                                                            Delete work order
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="success" className="btn btn-rounded" onClick={handleSendForApproval} >
                                                            Send work order for Approval
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </>
                                      )}
                                      {(workStatus == 'Pending Approval') && allowedToSubmit && (
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" className="btn btn-rounded" onClick={handleCancelApproval} >
                                                            Cancel Approval Request
                                                        </Button>
                                                    </div>
                                                </Col>
                                              
                                            </>
                                      )}
                                     
                                </Row>
                                   </CardBody>
                                </Card>)}
                                {(workStatus == 'Pending Approval') && (userId == approverId) && (
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Approve/Reject (You are the approver)</h5>
                                            <CardBody>
                                                <Row className="mb-2 mt-3 justify-content-center">
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Action</label>
                                                            <select className="form-select" value={action} onChange={(e)=>setAction(e.target.value)}>
                                                                <option value=""></option>
                                                                <option value="Approve">Approve</option>
                                                                <option value="Reject">Reject</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Comment</label>
                                                            <textarea className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <div className="d-grid gap-2">
                                                            <Button color="primary" className="btn" onClick={handleApproval}>
                                                                Submit response...
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                      )}

                               {/* <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Previous works done at {taskFacilityName}</h5>
                                <CardBody>
                                <div>
                                {(previousWorks.length > 0) ? (
                                            <>
                                      	    {previousWorks.map((a,k)=>(
                                                <div key={k}>
                                                    <p className="text-muted"><i className="mdi mdi-chevron-right text-primary me-1" />{" "} {new Date(a.assignedOn).toISOString().split('T')[0]}   {a.title} - {a.card}</p>
                                             
                                                </div>
                                            ))}
                                               
                                            </>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No work history at this facility</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                            
                     
                                        </div>

               
                                    
                                     
                                            </CardBody>
                                        </Card> */}
                                        </Col>
                            </Row>
                            <Row>
                            
                
                        
                        </Row>
                      


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default WorkOrderDetails;